import React, { useEffect } from "react";

export function useAxeAccessibility() {
  useEffect(() => {
    if (__DEV__) {
      Promise.all([import("@axe-core/react"), import("react-dom")]).then(
        ([axe, ReactDOM]) => {
          axe.default(React, ReactDOM, 1000);
        },
      );
    }
  }, []);
}
